<template>
    <div>
<!-- edit Components Checkbox  -->
        <ul uk-accordion>
            <li class="uk-open">
                <a class="uk-accordion-title" href="#">
                    <h2 class="Select_size_title">{{get_local_string.string_96}}
                        <span class="bolletsNode">4</span>
                    </h2>
                </a>
                <div class="uk-accordion-content">
                    <div class="row">
                       <!-- <p style="color:black"> {{getbox_details.max_comp}}</p> -->
                        <template v-for="(component) in getbox_details.components">
                            <!-- <p :key="component.id" style="color:black">{{component}}</p> -->
                            <div v-if="component.is_radio==1" :key="component.id" :class="`cateup_${component.cat_id}`">
                            <h4 class="col-xl-12 " :key="component.id">{{component.name}}</h4>
                            <div class="row row_radio">
                                <div class="col-6" v-for="comp in  component.data"
                                :key="comp.id">
                                <div class="component_extra_box">
                                    <div class="img_comp_exta_box">
                                       <template v-if="comp.image">
                                           <img :src="comp.image" :alt="comp.name">
                                        </template>
                                        <template v-else>
                                            <img class="item_img" :src="get_setting_app.logo" alt="logo">
                                        </template>
                                    </div>
                                    <div class="title_comp_exta_box">
                                        <div class="name_prod_comp_extra">{{comp.name}}
                                        </div>
                                        <span class="double_extra" v-if="comp.extra!=0">
                                            <label>
                                                <input @change="change_extra($event)"
                                                    :extra-price="comp.extra_price"
                                                    :value="comp.id" v-model="componentsData.extra"
                                                    class="ms-0 me-1 cr extra_component"
                                                    :class="[`extra-${comp.id}`]" name=""
                                                    name_extra="Tomatsaus" type="checkbox">
                                                <span class="price_extra_line2">
                                                    {{get_local_string.string_97}}
                                                    {{comp.extra_price}}{{get_setting_app.payment.currency}}</span>
                                            </label>
                                        </span>
                                    </div>
                                    <div class="add_comp_extra_box">
                                        <label >
                                            <template >
                                                <input @change="change_checked($event)"
                                                    :main-price="comp.price"
                                                    :class="`cr comp main_component radioshape radioshape_${component.cat_id} check-${comp.id}`"
                                                    v-model="componentsData.component"
                                                    :catid="component.cat_id"
                                                    name_comp="" :name="`group_${component.cat_id}`"
                                                    :value="comp.id" type="checkbox"
                                                    
                                                   >
                                                   <!-- :required="req" -->
                                            </template>
                                        </label>
                                        <!-- price main -->
                                            <span class="price_extra_line"
                                                v-show="comp.price==0?'':comp.price">{{comp.price}}{{get_setting_app.payment.currency}}</span>
                                    </div>
                                </div>
                            </div>
                            </div>
                            </div>
                         <!-- check box => -->
                            <div v-else :key="component.id">
                             <h4 class="col-xl-12 " :key="component.id">{{component.name}}</h4>
                            <div class="col-xl-6" v-for="comp in  component.data"
                                :key="comp.id">
                                <div class="component_extra_box">
                                    <div class="img_comp_exta_box">
                                       <template v-if="comp.image">
                                           <img :src="comp.image" :alt="comp.name">
                                        </template>
                                        <template v-else>
                                            <img class="item_img" :src="get_setting_app.logo" alt="logo">
                                        </template>
                                    </div>
                                    <div class="title_comp_exta_box">
                                        <div class="name_prod_comp_extra">{{comp.name}}
                                        </div>
                                        <span class="double_extra" v-if="comp.extra!=0">
                                            <label>
                                                <input @change="change_extra($event)"
                                                    :extra-price="comp.extra_price"
                                                    :value="comp.id" v-model="componentsData.extra"
                                                    class="ms-0 me-1 cr extra_component"
                                                    :class="[`extra-${comp.id}`]" name=""
                                                    name_extra="Tomatsaus" type="checkbox">
                                                <span class="price_extra_line2">
                                                    {{get_local_string.string_97}}
                                                    {{comp.extra_price}}{{get_setting_app.payment.currency}}</span>
                                            </label>
                                        </span>
                                    </div>
                                    <div class="add_comp_extra_box">
                                        <label :class="{'fixed_comp':comp.basic==2}">
                                            <!-- price main -->
                                            <span class="price_extra_line"
                                                v-show="comp.price==0?'':comp.price">{{comp.price}}{{get_setting_app.payment.currency}}</span>
                                            <!-- if component is fiexed basic ==2 -->
                                            <template v-if="comp.basic==2">
                                                <input @change="change_checked($event)"
                                                    :main-price="comp.price"
                                                    class="cr comp main_component"
                                                    v-model="componentsData.component"
                                                    name_comp="Tomatsaus" name=""
                                                    :value="comp.id" type="checkbox" checked
                                                    :class="[`check-${comp.id}`]">
                                            </template>
                                            <template v-if="comp.basic==1">
                                                <input @change="change_checked($event)"
                                                    :main-price="comp.price"
                                                    class="cr comp main_component"
                                                    v-model="componentsData.component"
                                                    name_comp="Tomatsaus" name=""
                                                    :value="comp.id" type="checkbox" checked
                                                    :class="[`check-${comp.id}`]">
                                            </template>
                                            <template v-if="comp.basic==0">
                                                <input @change="change_checked($event)"
                                                    :main-price="comp.price"
                                                    class="cr comp main_component"
                                                    v-model="componentsData.component"
                                                    name_comp="Tomatsaus" name=""
                                                    :value="comp.id" type="checkbox"
                                                    :class="[`check-${comp.id}`]">
                                            </template>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </template>
                    </div>
                    <!-- end box 1 -->
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
 import $ from 'jquery';
import { mapGetters } from 'vuex';
export default {
    name:'Components_til_checkbox',
    props:['componentsData' , 'getbox_details' , 'extra_sum'],
    data(){
        return{
            // declrate this var because vue not allow to edit from child to parents ,#
            //  you must change local after that change in the parents #
            // error syntax in console=> Avoid mutating a prop directly since the value will be overwritten whenever the parent component re-renders. Instead, use a data or computed property based on the prop’s value. Prop being mutated
            
            extra_sum_content : this.extra_sum,
            data_box_prop: this.getbox_details
            // req:true,
        }
    }
    ,
     computed:{
        ...mapGetters({
             get_setting_app:'get_setting_app',
               get_local_string:'get_local_string'
        })
    },
    methods:{
        // change checkbox extra Parents 
            change_checked(event) {
                if(this.data_box_prop.max_comp>0){
                    var num_of_choose =  $('.uk-accordion-content input.main_component:checkbox:checked').length;
                    if(num_of_choose == this.data_box_prop.max_comp){
                        console.log(num_of_choose)
                    $('.uk-accordion-content input.main_component:checkbox').not(':checked').attr("disabled", true);
                    }
                    else{
                    console.log(num_of_choose)
                     $('.uk-accordion-content input.main_component:checkbox').attr("disabled", false);
                }
                }
                // console.log(this.data_box_prop , 'prop data')
                
                 let app = this;
                if (event.srcElement.checked) {
                    //radio edit
                   if(event.srcElement.classList.contains('radioshape')){
                    //    foreach
                       $('.radioshape_'+event.target.attributes.catid.value).each(function(){    
                      //console.log($('.cateup_22 input')[0].required = true,'from cate22');
                        $('span.radioshape_'+event.target.attributes.catid.value).addClass('okhide');
                        let index_of_removeed_item =  app.componentsData.component.indexOf(parseInt($(this).val()));
                        if(index_of_removeed_item !=-1 && event.target.value!=$(this).val()){
                            console.log(event.target._value);
                            // extra small
                            $(`.extra-${$(this).val()}`).parents('.double_extra').hide();
                             // =========24sep
                            console.log('24sep')
                            app.componentsData.price = parseFloat(app.componentsData.price) - parseFloat($(`input.check-${$(this).val()}`).attr('main-price'));
                            // ======= 24sep
                            if ($(event.target).parents('.component_extra_box').find('input.extra_component').length) {
                        if ($(`input.extra-${$(this).val()}`).is(':checked')) {
                            // if user remove parent extra comp => must remove extra child;
                            // get index of child extra to remove from extra arr
                            let index_child_extra = app.componentsData.extra.indexOf($(this).val());
                            app.componentsData.extra.splice(index_child_extra, 1);
                            // ### change Price Total
                            app.componentsData.price = parseFloat(app.componentsData.price) - parseFloat($(`input.extra-${$(this).val()}`).attr('extra-price'));
                            // ### Total Price From Extra Components 
                            app.extra_sum_content -= parseFloat($(`input.extra-${$(this).val()}`).attr('extra-price'));
                            app.$emit('change-check-extra', this.extra_sum_content);
                        }
                            }
                            // 
                            app.componentsData.component.splice(index_of_removeed_item, 1);
                        }
                        $(`span.extra-${event.target._value}`).removeClass('okhide');
                       })
                    }
                    // end if radio
                  
                    // end radio
                    $(`.extra-${event.target._value}`).parents('.double_extra').show();
                    $(`span.extra-${event.target._value}`).show();
                    // ### change Price Total
                    this.componentsData.price = parseFloat(this.componentsData.price) + parseFloat($(event.srcElement).attr('main-price'));
                    // ### Total Price From Extra Components 
                    this.extra_sum_content += parseFloat($(event.srcElement).attr('main-price'));
                    // emit send extra sum to parents 
                    this.$emit('change-check-extra', this.extra_sum_content);
                }
                else {
                    $(`.extra-${event.target._value}`).parents('.double_extra').hide();
                    $(`span.extra-${event.target._value}`).hide();
                    // remove class extra from span 
                    $(`span.extra-${event.target._value}`).removeClass('extra_added');
                    // remove price from total when user remove parent extra comp 
                    if ($(event.target).parents('.component_extra_box').find('input.extra_component').length) {
                        if ($(`input.extra-${event.target._value}`).is(':checked')) {
                            // if user remove parent extra comp => must remove extra child;
                            // get index of child extra to remove from extra arr
                            let index_child_extra = this.componentsData.extra.indexOf(event.target._value);
                            this.componentsData.extra.splice(index_child_extra, 1);
                            // ### change Price Total
                            this.componentsData.price = parseFloat(this.componentsData.price) - parseFloat($(`input.extra-${event.target._value}`).attr('extra-price'));
                            // ### Total Price From Extra Components 
                            this.extra_sum_content -= parseFloat($(`input.extra-${event.target._value}`).attr('extra-price'));
                            this.$emit('change-check-extra', this.extra_sum_content);
                        }
                    }
                    // remove price from parent extra
                    // ### change Price Total
                    this.componentsData.price = parseFloat(this.componentsData.price) - parseFloat($(event.srcElement).attr('main-price'));
                    // ### Total Price From Extra Components 
                    this.extra_sum_content -= parseFloat($(event.srcElement).attr('main-price'));
                    this.$emit('change-check-extra', this.extra_sum_content);
                }
            },
            // change checkbox extra child    
            change_extra(event) {
                if (event.srcElement.checked)  //if child is checked
                {
                     console.log(this.componentsData.extra ,' consoel extra arr')
                    // add  Bold Extra -word-  To span in desc products 
                    $(`span.extra-${event.target._value}`).addClass('extra_added');
                    // ### change Price Total
                    this.componentsData.price = parseFloat(this.componentsData.price) + parseFloat($(event.srcElement).attr('extra-price'));
                    this.extra_sum_content += parseFloat($(event.srcElement).attr('extra-price'));
                    this.$emit('change-check-extra', this.extra_sum_content);
                }
                else {
                    // remove  Bold Extra -word-  To span in desc products 
                    $(`span.extra-${event.target._value}`).removeClass('extra_added');
                    //### change Price Total
                    this.componentsData.price = parseFloat(this.componentsData.price) - parseFloat($(event.srcElement).attr('extra-price'));
                    this.extra_sum_content -= parseFloat($(event.srcElement).attr('extra-price'));
                    this.$emit('change-check-extra', this.extra_sum_content);
                }
            }
    },

  
    }
</script>
<style lang="scss" scoped>
.main_component:disabled{
    background-color: grey;
}
.uk-accordion-content{
    overflow-x: hidden;
}
 .mb-100 {
        margin-bottom: 100px;
    }
  .Select_size_title {
        font-size: 14px;
        font-family: "Montserrat", sans-serif;
        font-weight: 600;
        color: black;
        margin-top: 25px;
    }
    .bolletsNode {
        border-radius: 500%;
        background: var(--active_color);
        color: black;
        height: 30px;
        width: 30px;
        transition: all 500ms ease-in-out;
        text-align: center;
        line-height: 30px;
        margin-left: -25px;
        position: absolute;
        left: 0px;
        margin-top: -8px;
    }
  // start extra
    .component_extra_box {
        display: flex;
           background-color: #dedede;
         border: 1px solid #f5f5f5;
        padding-top: 12px;
        padding: 10px;
        border-radius: 10px;
        align-items: center;
        margin-bottom: 4px;
    }

    .img_comp_exta_box {
        flex: 0 0 70px;

        img {
            cursor: pointer;
            overflow: visible;
            width: 100%;
            height: 60px;
            object-fit: contain;
        }
    }

    .title_comp_exta_box {
        width: 200px;
        color: var(--second_color);;
        padding-left: 20px;
    }

    .name_prod_comp_extra {
        font-size: 14px;
        color: var(--second_color);
    }

    .double_extra {
        display: block;
    }

    .add_comp_extra_box {
        margin-left: auto;
    }

    .add_comp_extra_box label {
        display: flex;
        align-items: flex-end;
        flex-direction: column-reverse;
    }

    .price_extra_line {
       font-size: 15px;
    margin-top: 7px;
    color: #000000;
    font-weight: 500;
    }

    input.cr {
        -webkit-appearance: none;
        box-sizing: border-box;
        margin: 0;
        border-radius: 0;
        font: inherit;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background-color: #fffcfc;
        border-color: #fefcfc !important;
        background-image: url('../../../../assets/add_extra.png');
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
    }
        input.radioshape{
        background-image: none !important;
    }
    input.main_component:disabled{
            background-color: #b3b3b3 !important;
    }
    input.radioshape:checked{
         background-image: url('../../../../assets/checks.svg') !important;
    }
    .row_radio{
        .price_extra_line{
            font-size: 14px;
        }
        .img_comp_exta_box{
            display: none;
        }
        .title_comp_exta_box{
            padding-left: 0px;
        }
        .name_prod_comp_extra{
            font-size: 13px;
        }
    }

    input.cr:checked {
        background-image: url('../../../../assets/del.svg');
        background-size: 15px;
        background-position: center center;
        background-repeat: no-repeat;
        background-color: var(--active_color) !important;
        color: var(--second_color);
        border-color: transparent;
    }
    .price_extra_line2 {
        font-size: 13px;
    }

    .double_extra label {
        padding-top: 10px;
        display: flex;
        align-items: center;
    }

    .uk-accordion {
        padding: 0;
        list-style: none;
        margin-top: 40px;
    }

    h4.col-xl-12::after {
        content: '';
        width: 80%;
        height: 2px;
        background-color: #000;
        position: absolute;
        top: 13px;
        margin-left: 10px;
    }

    h4.col-xl-12 {
        margin: unset;
        color: #000;
        font-weight: 600;
        position: relative;
        margin-bottom: 24px;
    }

    .fixed_comp {
        pointer-events: none;
    }

    .fixed_comp input.cr {
        background-color: gray !important;
    }

    .double_extra {
        display: none;
    }
</style>